/**
 * Custom hook to determine the language according to the configuration of the catalog
 * based system language
 * @example const getLocalizedLabel = useLocalizedLabel(); 
 */
import { useTranslation } from "react-i18next";

const useLocalizedLabel = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "es";

  const getLocalizedLabel = (item) => {
    if (!item) return "";
    const { locales = {}, label } = item;
    const labelFromLocale = locales[lang] || Object.values(locales)[0];
    return labelFromLocale || label || "";
  };

  return getLocalizedLabel;
};

export default useLocalizedLabel;
